(function () {
  'use strict';

  var SHIPPING_TAG = 'shipping';
  var QUOTE_MAX_QTY = 7;
  var SHIPPING_DATE_LABEL = 'Requested Ship Date';
  var productTagCache = {};

  var pickeasySelectors = [
    'pickeasy-app-widget',
    'pickeasy-store-pickup',
    'pickeasy-local-delivery',
    'pickeasy-slot-picker',
    'pickeasy-pickup-popup',
    '[class*="pickeasy"]',
    '[id*="pickeasy"]',
    '[class*="pc-widget"]',
    '[id*="pc-widget"]',
    '[data-pc-widget]',
    '[data-pickeasy]',
    '[class*="order-delivery-date"]',
    '[id*="order-delivery-date"]'
  ];

  var pickupLocalSelectors = [
    'pickeasy-store-pickup',
    'pickeasy-local-delivery',
    'pickeasy-pickup-popup'
  ];

  var state = {
    fundraiserOnly: false,
    shippingOnly: false,
    blockReason: null,
    pickeasyObserver: null,
    hideRetryTimer: null,
    lastCart: null,
    lastClassification: null
  };

  var cartFetchPromise = null;
  var cartFetchCache = null;
  var syncDebounceTimer = null;

  function tagMap() {
    return (window.ssbCartFulfillment && window.ssbCartFulfillment.tagMap) || {};
  }

  function isFundraiserOnlyCart(cart) {
    if (!cart || !cart.items || cart.items.length === 0) return false;
    return cart.items.every(function (item) {
      return item.title.toLowerCase().indexOf('(fundraiser)') !== -1;
    });
  }

  function productHasShippingTag(tags) {
    if (!tags || !tags.length) return false;
    return tags.some(function (tag) {
      return String(tag).toLowerCase() === SHIPPING_TAG;
    });
  }

  function fetchProductTags(handle) {
    if (!handle) return Promise.resolve([]);
    if (productTagCache[handle]) return Promise.resolve(productTagCache[handle]);

    return fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (response) {
        if (!response.ok) throw new Error('product fetch failed');
        return response.json();
      })
      .then(function (product) {
        productTagCache[handle] = product.tags || [];
        return productTagCache[handle];
      })
      .catch(function () {
        productTagCache[handle] = [];
        return [];
      });
  }

  function isVariantShipping(item) {
    var map = tagMap();
    var variantId = String(item.variant_id);

    if (Object.prototype.hasOwnProperty.call(map, variantId)) {
      return Promise.resolve(!!map[variantId]);
    }

    return fetchProductTags(item.handle).then(function (tags) {
      var isShipping = productHasShippingTag(tags);
      map[variantId] = isShipping;
      return isShipping;
    });
  }

  function classifyCart(cart) {
    if (!cart || !cart.items || cart.items.length === 0) {
      return Promise.resolve({
        fundraiserOnly: false,
        hasShippingItems: false,
        hasNonShippingItems: false,
        shippingQty: 0,
        blockReason: null
      });
    }

    if (isFundraiserOnlyCart(cart)) {
      return Promise.resolve({
        fundraiserOnly: true,
        hasShippingItems: false,
        hasNonShippingItems: false,
        shippingQty: 0,
        blockReason: null
      });
    }

    return Promise.all(
      cart.items.map(function (item) {
        return isVariantShipping(item).then(function (isShipping) {
          return { item: item, isShipping: isShipping };
        });
      })
    ).then(function (entries) {
      var hasShippingItems = false;
      var hasNonShippingItems = false;
      var shippingQty = 0;

      entries.forEach(function (entry) {
        if (entry.isShipping) {
          hasShippingItems = true;
          shippingQty += entry.item.quantity;
        } else {
          hasNonShippingItems = true;
        }
      });

      var blockReason = null;
      if (hasShippingItems && hasNonShippingItems) {
        blockReason = 'mixed';
      } else if (hasShippingItems && shippingQty >= QUOTE_MAX_QTY) {
        blockReason = 'quote';
      }

      return {
        fundraiserOnly: false,
        hasShippingItems: hasShippingItems,
        hasNonShippingItems: hasNonShippingItems,
        shippingQty: shippingQty,
        blockReason: blockReason
      };
    });
  }

  function hidePickeasy(scope) {
    var root = scope || document;
    pickeasySelectors.forEach(function (sel) {
      root.querySelectorAll(sel).forEach(function (el) {
        el.style.setProperty('display', 'none', 'important');
      });
    });

    root.querySelectorAll('cart-drawer .drawer__footer > *').forEach(function (el) {
      if (
        el.matches(
          '.cart-drawer__footer, .ssb-drawer-back, .cart__ctas, details, cart-note, .ssb-cart-fulfillment-alerts, [data-ssb-cart-alerts]'
        )
      ) {
        return;
      }
      el.style.setProperty('display', 'none', 'important');
    });
  }

  function showPickeasy(scope) {
    var root = scope || document;
    pickeasySelectors.forEach(function (sel) {
      root.querySelectorAll(sel).forEach(function (el) {
        el.style.removeProperty('display');
      });
    });

    root.querySelectorAll('cart-drawer .drawer__footer > *').forEach(function (el) {
      if (
        el.matches(
          '.cart-drawer__footer, .ssb-drawer-back, .cart__ctas, details, cart-note, .ssb-cart-fulfillment-alerts, [data-ssb-cart-alerts]'
        )
      ) {
        return;
      }
      el.style.removeProperty('display');
    });
  }

  function clearPickupLocalHide(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-ssb-pickup-suppressed]').forEach(function (el) {
      el.style.removeProperty('display');
      delete el.dataset.ssbPickupSuppressed;
    });
  }

  function hidePickupLocationSections(root) {
    var containers = root.querySelectorAll(
      'cart-drawer .drawer__footer, .cart__blocks, .main-cart-footer, #main-cart-footer'
    );

    containers.forEach(function (container) {
      container.querySelectorAll('*').forEach(function (el) {
        if (el.dataset.ssbPickupSuppressed) return;
        if (el.children.length > 0) return;

        var label = el.textContent.trim();
        if (!/^pickup locations?$/i.test(label)) return;

        var target = el.parentElement;
        if (!target || target === container) return;

        target.style.setProperty('display', 'none', 'important');
        target.dataset.ssbPickupSuppressed = '1';
      });
    });
  }

  function hidePickupAndLocal(scope) {
    var root = scope || document;

    pickupLocalSelectors.forEach(function (sel) {
      root.querySelectorAll(sel).forEach(function (el) {
        el.style.setProperty('display', 'none', 'important');
        el.dataset.ssbPickupSuppressed = '1';
      });
    });

    hidePickupLocationSections(root);
  }

  function updateShippingDateLabel(scope) {
    if (!state.shippingOnly) return;

    var root = scope || document;
    var containers = root.querySelectorAll(
      'cart-drawer .drawer__footer, .cart__blocks, .main-cart-footer, #main-cart-footer, pickeasy-app-widget, pickeasy-slot-picker'
    );

    containers.forEach(function (container) {
      container.querySelectorAll('*').forEach(function (el) {
        if (el.children.length > 0) return;

        var text = el.textContent.trim();
        if (!/^when would you like to get this order\?$/i.test(text)) return;

        el.textContent = SHIPPING_DATE_LABEL;
        el.dataset.ssbShippingDateLabel = '1';
      });
    });
  }

  function applyShippingOnlyPickeasyUi(scope) {
    hidePickupAndLocal(scope);
    updateShippingDateLabel(scope);
  }

  function setShippingOnlyMode(enabled) {
    var drawer = document.querySelector('cart-drawer');
    var cartItems = document.querySelector('cart-items');

    if (drawer) drawer.classList.toggle('ssb-shipping-only', enabled);
    if (cartItems) cartItems.classList.toggle('ssb-shipping-only', enabled);
    document.body.classList.toggle('ssb-shipping-only-cart', enabled);
  }

  function isShippingOnlyCart(classification) {
    return (
      !classification.fundraiserOnly &&
      !classification.blockReason &&
      classification.hasShippingItems &&
      !classification.hasNonShippingItems
    );
  }

  function clearStaleFundraiserAttributes(cart) {
    if (!cart || !cart.attributes) return Promise.resolve(cart);

    var attrs = cart.attributes;
    if (!attrs['Fundraiser Name'] && !attrs['Fundraiser Collection URL'] && !attrs['Student Name']) {
      return Promise.resolve(cart);
    }

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        attributes: {
          'Fundraiser Name': '',
          'Fundraiser Collection URL': '',
          'Student Name': ''
        }
      })
    }).then(function (response) {
      return response.json();
    });
  }

  function isCartEmpty() {
    return !!(
      document.querySelector('cart-drawer.is-empty') ||
      document.querySelector('cart-items.is-empty')
    );
  }

  function setCheckoutDisabled(disabled, reason) {
    ['checkout', 'CartDrawer-Checkout'].forEach(function (id) {
      var btn = document.getElementById(id);
      if (!btn) return;

      if (disabled) {
        btn.setAttribute('disabled', 'disabled');
        btn.setAttribute('aria-disabled', 'true');
        btn.dataset.ssbShippingBlocked = reason || '1';
        return;
      }

      if (!btn.dataset.ssbShippingBlocked) return;

      delete btn.dataset.ssbShippingBlocked;

      if (isCartEmpty()) {
        btn.setAttribute('disabled', 'disabled');
        btn.setAttribute('aria-disabled', 'true');
        return;
      }

      btn.removeAttribute('disabled');
      btn.removeAttribute('aria-disabled');
    });
  }

  function updateAlerts(blockReason) {
    document.querySelectorAll('[data-ssb-cart-alerts]').forEach(function (container) {
      var mixed = container.querySelector('.ssb-cart-alert-mixed');
      var quote = container.querySelector('.ssb-cart-alert-quote');
      if (mixed) mixed.hidden = blockReason !== 'mixed';
      if (quote) quote.hidden = blockReason !== 'quote';
    });
  }

  function bindFundraiserCheckoutOverride() {
    [
      { id: 'checkout', active: function () { return state.fundraiserOnly; } },
      { id: 'CartDrawer-Checkout', active: function () { return state.fundraiserOnly; } }
    ].forEach(function (cfg) {
      var btn = document.getElementById(cfg.id);
      if (!btn || btn.dataset.ssbFundraiserBound) return;
      btn.dataset.ssbFundraiserBound = '1';
      btn.addEventListener(
        'click',
        function (e) {
          if (!cfg.active()) return;
          e.stopImmediatePropagation();
          e.preventDefault();
          window.location.href = '/checkout';
        },
        true
      );
    });
  }

  function startPickeasyObserver() {
    if (state.pickeasyObserver) return;

    state.pickeasyObserver = new MutationObserver(function () {
      if (state.fundraiserOnly || state.blockReason) hidePickeasy();
      else if (state.shippingOnly) applyShippingOnlyPickeasyUi();
    });

    var drawerFooter = document.querySelector('cart-drawer .drawer__footer');
    if (drawerFooter) {
      state.pickeasyObserver.observe(drawerFooter, { childList: true, subtree: true });
    }
    state.pickeasyObserver.observe(document.body, { childList: true, subtree: true });
  }

  function schedulePickeasyHideRetry() {
    clearTimeout(state.hideRetryTimer);
    if (!state.fundraiserOnly && !state.blockReason && !state.shippingOnly) return;

    [0, 100, 250, 500, 1000, 2000, 3500].forEach(function (delay) {
      setTimeout(function () {
        if (state.fundraiserOnly || state.blockReason) hidePickeasy();
        else if (state.shippingOnly) applyShippingOnlyPickeasyUi();
      }, delay);
    });

    state.hideRetryTimer = setTimeout(function () {
      if (state.fundraiserOnly || state.blockReason) hidePickeasy();
      else if (state.shippingOnly) applyShippingOnlyPickeasyUi();
    }, 5000);
  }

  function applyCartState(classification) {
    state.fundraiserOnly = classification.fundraiserOnly;
    state.blockReason = classification.blockReason;
    state.shippingOnly = isShippingOnlyCart(classification);

    var drawer = document.querySelector('cart-drawer');

    if (classification.fundraiserOnly) {
      hidePickeasy();
      bindFundraiserCheckoutOverride();
      startPickeasyObserver();
      schedulePickeasyHideRetry();
      setCheckoutDisabled(false);
      updateAlerts(null);
      setShippingOnlyMode(false);
      if (drawer) drawer.classList.add('ssb-fundraiser-only');
      if (drawer) drawer.classList.remove('ssb-shipping-blocked');
      return;
    }

    if (drawer) drawer.classList.remove('ssb-fundraiser-only');

    if (classification.blockReason) {
      hidePickeasy();
      startPickeasyObserver();
      schedulePickeasyHideRetry();
      setCheckoutDisabled(true, classification.blockReason);
      updateAlerts(classification.blockReason);
      setShippingOnlyMode(false);
      if (drawer) drawer.classList.add('ssb-shipping-blocked');
      return;
    }

    if (state.shippingOnly) {
      showPickeasy();
      applyShippingOnlyPickeasyUi();
      startPickeasyObserver();
      schedulePickeasyHideRetry();
      setShippingOnlyMode(true);
      setCheckoutDisabled(false);
      updateAlerts(null);
      if (drawer) drawer.classList.remove('ssb-shipping-blocked');
      return;
    }

    clearPickupLocalHide();
    showPickeasy();
    setShippingOnlyMode(false);
    setCheckoutDisabled(false);
    updateAlerts(null);
    if (drawer) drawer.classList.remove('ssb-shipping-blocked');
  }

  function setCartCache(cart) {
    cartFetchCache = cart;
    state.lastCart = cart;
  }

  function fetchCart() {
    if (cartFetchCache) {
      return Promise.resolve(cartFetchCache);
    }

    if (cartFetchPromise) {
      return cartFetchPromise;
    }

    cartFetchPromise = fetch('/cart.js')
      .then(function (response) {
        if (!response.ok) throw new Error('cart fetch failed');
        return response.json();
      })
      .then(function (cart) {
        setCartCache(cart);
        return cart;
      })
      .finally(function () {
        cartFetchPromise = null;
      });

    return cartFetchPromise;
  }

  function resolveCart(existingCart) {
    if (existingCart && existingCart.items) {
      setCartCache(existingCart);
      return Promise.resolve(existingCart);
    }

    if (existingCart && existingCart.cartData && existingCart.cartData.items) {
      setCartCache(existingCart.cartData);
      return Promise.resolve(existingCart.cartData);
    }

    return fetchCart();
  }

  function syncCartFulfillment(existingCart) {
    return resolveCart(existingCart)
      .then(function (cart) {
        if (typeof window.ssbSyncSubjSuffix === 'function') {
          window.ssbSyncSubjSuffix(cart);
        }

        return refreshTagMapFromCart(cart).then(function () {
          return classifyCart(cart).then(function (classification) {
            state.lastClassification = classification;

            if (isShippingOnlyCart(classification)) {
              return clearStaleFundraiserAttributes(cart).then(function (updatedCart) {
                if (updatedCart && updatedCart.items) {
                  setCartCache(updatedCart);
                }
                return applyCartState(classification);
              });
            }
            return applyCartState(classification);
          });
        });
      })
      .catch(function () {});
  }

  function scheduleSyncCartFulfillment(existingCart) {
    clearTimeout(syncDebounceTimer);
    syncDebounceTimer = setTimeout(function () {
      syncCartFulfillment(existingCart);
    }, 50);
  }

  function isVariantShippingKnown(item) {
    var map = tagMap();
    var variantId = String(item.variant_id);
    if (Object.prototype.hasOwnProperty.call(map, variantId)) {
      return map[variantId];
    }
    return null;
  }

  function refreshTagMapFromCart(cart) {
    if (!cart || !cart.items || cart.items.length === 0) {
      return Promise.resolve();
    }

    return Promise.all(
      cart.items.map(function (item) {
        if (isVariantShippingKnown(item) !== null) {
          return Promise.resolve();
        }
        return isVariantShipping(item);
      })
    );
  }

  function wouldMixCart(cart, addingShipping) {
    if (!cart || !cart.items || cart.items.length === 0) {
      return Promise.resolve(false);
    }

    if (isFundraiserOnlyCart(cart)) {
      return Promise.resolve(false);
    }

    var hasShipping = false;
    var hasNonShipping = false;
    var unknownItems = [];

    cart.items.forEach(function (item) {
      var known = isVariantShippingKnown(item);
      if (known === null) {
        unknownItems.push(item);
        return;
      }
      if (known) hasShipping = true;
      else hasNonShipping = true;
    });

    function resolveMix() {
      if (addingShipping) return hasNonShipping;
      return hasShipping;
    }

    if (unknownItems.length === 0) {
      return Promise.resolve(resolveMix());
    }

    return Promise.all(
      unknownItems.map(function (item) {
        return isVariantShipping(item);
      })
    ).then(function (flags) {
      flags.forEach(function (isShipping) {
        if (isShipping) hasShipping = true;
        else hasNonShipping = true;
      });
      return resolveMix();
    });
  }

  function hideAddError(productForm) {
    var wrapper = productForm.querySelector('[data-ssb-shipping-add-error]');
    if (wrapper) wrapper.hidden = true;
    productForm.handleErrorMessage(false);
  }

  function showAddError(productForm) {
    var wrapper = productForm.querySelector('[data-ssb-shipping-add-error]');
    if (wrapper) {
      wrapper.hidden = false;
      return;
    }

    productForm.handleErrorMessage(
      "This item can't be combined with the other fulfillment type in your cart. Clear your cart or remove conflicting items to continue."
    );
  }

  function bindAddErrorActions(productForm) {
    var wrapper = productForm.querySelector('[data-ssb-shipping-add-error]');
    if (!wrapper || wrapper.dataset.ssbBound) return;
    wrapper.dataset.ssbBound = '1';

    wrapper.querySelector('[data-ssb-dismiss-add-error]')?.addEventListener('click', function () {
      hideAddError(productForm);
      productForm.submitButton?.removeAttribute('aria-disabled');
      productForm.submitButton?.classList.remove('loading');
      productForm.querySelector('.loading__spinner')?.classList.add('hidden');
    });

    wrapper.querySelector('[data-ssb-clear-and-add]')?.addEventListener('click', function () {
      fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .then(function () {
          hideAddError(productForm);
          productForm.dataset.ssbSkipMixCheck = 'true';
          productForm.form?.requestSubmit(productForm.submitButton);
        })
        .catch(function () {
          showAddError(productForm);
        });
    });
  }

  function cartIsEmpty(cart) {
    return !cart || !cart.items || cart.items.length === 0;
  }

  function canSkipMixCheck(addingShipping) {
    var cart = state.lastCart || cartFetchCache;

    if (!cart) {
      return false;
    }

    if (cartIsEmpty(cart)) {
      return true;
    }

    var classification = state.lastClassification;
    if (!classification) {
      return false;
    }

    if (addingShipping && !classification.hasNonShippingItems) {
      return true;
    }

    if (!addingShipping && !classification.hasShippingItems) {
      return true;
    }

    return false;
  }

  function finishMixValidation(blocked, productForm) {
    if (!blocked) {
      hideAddError(productForm);
      return true;
    }
    showAddError(productForm);
    return false;
  }

  function validateAddToCart(addingShipping, productForm) {
    bindAddErrorActions(productForm);

    if (productForm.dataset.ssbSkipMixCheck === 'true') {
      delete productForm.dataset.ssbSkipMixCheck;
      return Promise.resolve(true);
    }

    if (canSkipMixCheck(addingShipping)) {
      hideAddError(productForm);
      return Promise.resolve(true);
    }

    var cartPromise = cartFetchPromise || (state.lastCart || cartFetchCache
      ? Promise.resolve(state.lastCart || cartFetchCache)
      : fetchCart());

    return cartPromise
      .then(function (cart) {
        return wouldMixCart(cart, addingShipping);
      })
      .then(function (blocked) {
        return finishMixValidation(blocked, productForm);
      })
      .catch(function () {
        return true;
      });
  }

  function invalidateCartCache() {
    cartFetchCache = null;
  }

  function initListeners() {
    document.addEventListener('DOMContentLoaded', function () {
      syncCartFulfillment();
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.cartData && event.cartData.items) {
          setCartCache(event.cartData);
        } else {
          invalidateCartCache();
        }
        scheduleSyncCartFulfillment(event);
      });
    }

    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.attributeName === 'class' && drawer.classList.contains('active')) {
            scheduleSyncCartFulfillment();
          }
        });
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
  }

  window.ssbCartFulfillment = window.ssbCartFulfillment || {};
  window.ssbCartFulfillment.tagMap = window.ssbCartFulfillment.tagMap || {};
  window.ssbCartFulfillment.sync = syncCartFulfillment;
  window.ssbCartFulfillment.getCart = fetchCart;
  window.ssbCartFulfillment.validateAddToCart = validateAddToCart;
  window.ssbCartFulfillment.schedulePickeasyHideRetry = schedulePickeasyHideRetry;

  window.ssbSyncFundraiserCartDrawer = syncCartFulfillment;
  window.ssbScheduleFundraiserPickeasyHide = schedulePickeasyHideRetry;

  initListeners();
})();
